export default __webpack_public_path__ + "static/media/oleg.c5e1940f.jpg";